import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faMobileAlt,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import md5 from "blueimp-md5";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { setAuth } from "../authSlice";
import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";

export default function SignIn() {
  const reduxDispatch = useDispatch();
  const [data, setData] = useState({
    email: "",
    phone: "",
    password1: "",
    password2: "",
    code: "",
    name: "",
  });

  const [count, setCount] = useState({
    countdown: 60,
    flag: true,
  });

  const [err, setErr] = useState({
    email: false,
    phone: false,
    password1: false,
    password2: false,
    code: false,
    name: false,
  });

  const [hide, setHide] = useState(true);
  const [hide1, setHide1] = useState(true);
  const [isPhoneMode, setIsPhoneMode] = useState(false);

  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("auth");
  }, []);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignUpByPhoneCode = () => {
    (async (phone, code, password, name) => {
      const response = await fetch("/gin-api/candidate/sign-up-by-phone-code", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          phone: phone,
          code: code,
          password: md5(password),
          name: name,
        }),
      });
      if (response.status >= 500) {
        alert("服务器错误");
        return;
      }
      if (response.status <= 400) {
        alert("注册成功，即将跳转至登录页面。");
        location.href = "#/登录";
        return;
      }
      const respData = await response.json();
      if (respData.title) {
        alert(respData.title);
      }
      // const data = await response.json();
      // localStorage.setItem("auth", JSON.stringify(data));
      // reduxDispatch(setAuth(data));
      // saveJournal({
      // 	ref_id: data.id,
      // 	ref_id2: 0,
      // 	category: "登录",
      // 	tag: "个人用户",
      // 	ref_uuid: data.uuid,
      // 	ref_uuid2: "",
      // });
      // location.href = "#/";
    })(data.phone, data.code, data.password1, data.name);
  };

  const handleSignIn = async () => {
    const errData = {};
    const requiredFields = ["password1", "password2", "code", "name"];

    if (isPhoneMode) {
      requiredFields.push("phone");
    } else {
      requiredFields.push("email");
    }

    requiredFields.forEach((key) => {
      if (data[key].trim() === "") {
        errData[key] = "请填写内容";
      }
    });

    if (Object.getOwnPropertyNames(errData).length !== 0) {
      setErr(errData);
      return;
    }

    if (data.password1 !== data.password2) {
      setErr({
        password1: "请确认密码",
        password2: "请确认密码",
      });
      return;
    }
    if (isPhoneMode) {
      handleSignUpByPhoneCode();
      return;
    }

    const response = await fetch("/gin-api/candidate/sign-up-by-email-code", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        password: md5(data.password1),
        code: data.code,
        name: data.name,
        ...(isPhoneMode ? { phone: data.phone } : { email: data.email }),
      }),
    });
    if (response.status < 400) {
      alert("注册成功");
      history.back();
    }
    if (response.status >= 500) {
      alert("服务器错误");
      return;
    }
    const respData = await response.json();
    if (respData.title) {
      alert(respData.title);
    }
    // if (res.message) {
    //   let alertFlg = false;
    //   if (typeof res.message === "object") {
    //     Object.getOwnPropertyNames(res.message).forEach((key) => {
    //       switch (key) {
    //         case "phone":
    //           errData[key] = "该电话号已注册";
    //           break;
    //         case "name":
    //           errData[key] = "用户名已被使用";
    //           break;
    //         case "email":
    //           errData[key] = "该邮箱已注册";
    //           break;
    //         case "code":
    //           errData[key] = "验证码错误";
    //           break;
    //         default:
    //           alertFlg = true;
    //       }
    //     });
    //     alertFlg = true;
    //   } else {
    //     alertFlg = true;
    //   }
    //   if (alertFlg) {
    //     alert("输入信息存在错误，请仔细检查后重新输入");
    //   }
    //   setErr(errData);
    // } else {
    //   alert("注册成功");
    //   history.back();
    // }
  };

  const handleCode = () => {
    if (isPhoneMode) {
      const phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!phoneReg.test(data.phone)) {
        alert("请检查手机号格式是否输入正确");
        return;
      }
      fetch("/gin-api/ephemeral/phone", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          phone: data.phone,
          purpose: "注册",
        }),
      }).then((response) => {
        if (response.ok) {
          alert("验证码已发送到您的手机");
          startCountdown();
        } else {
          alert("验证码发送失败，请重新发送");
        }
      });
    } else {
      const emailReg =
        /^[a-zA-Z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (!emailReg.test(data.email)) {
        alert("请检查邮箱格式是否输入正确");
        return;
      }
      // fetch("/api/email/", {
      //   method: "PUT",
      //   headers: { "content-type": "application/json" },
      //   body: JSON.stringify({
      //     email: data.email,
      //     user_category: "个人用户",
      //   }),
      // })
      //   .then((res) => res.json())
      //   .then((res) => {
      //     if (res.message) {
      //       alert("验证码发送失败，请重新发送");
      //     } else {
      //       alert("验证码已发送到您的邮箱");
      //       startCountdown();
      //     }
      //   });
      fetch("/gin-api/ephemeral/email", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          email: data.email,
        }),
      }).then((response) => {
        if (response.status < 400) {
          alert("验证码已发送到您的邮箱");
          startCountdown();
        }
      })
    }
  };

  const startCountdown = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    setCount((prev) => ({ ...prev, flag: false, countdown: 60 }));
    timerRef.current = setInterval(() => {
      setCount((prev) => {
        if (prev.countdown <= 1) {
          clearInterval(timerRef.current);
          return { ...prev, flag: true, countdown: 60 };
        }
        return { ...prev, countdown: prev.countdown - 1 };
      });
    }, 1000);
  };

  const checkInput = () => {
    if (isPhoneMode) {
      return data.phone === "";
    }
    return data.email === "";
  };

  const onHide = (e) => {
    setHide(e);
  };

  const onHide1 = (e) => {
    setHide1(e);
  };

  return (
    <>
      <div className="container-fluid background-login">
        <ToBack />
        <div className="mt-4 bg-transparent text-white pt-5 text-center">
          <h4>
            <strong className="text-warning">Hi</strong>
            &nbsp;&nbsp;龙江学子就业平台
          </h4>
        </div>

        <div className="row bg-transparent text-dark">
          <div className="col">
            <div className="card border-0 bg-transparent text-dark">
              <div className="card-body card-p">
                <div className="text-center mb-3">
                  <button
                    type="button"
                    className={`btn btn-sm me-2 ${!isPhoneMode ? "btn-warning" : "btn-outline-light"}`}
                    onClick={() => setIsPhoneMode(false)}
                  >
                    邮箱注册
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${isPhoneMode ? "btn-warning" : "btn-outline-light"}`}
                    onClick={() => setIsPhoneMode(true)}
                  >
                    手机注册
                  </button>
                </div>
                <form>
                  {isPhoneMode ? (
                    <>
                      {err.phone && <small className="form-text text-danger">{err.phone}</small>}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-transparent text-white border-0">
                            <FontAwesomeIcon icon={faMobileAlt} fixedWidth size="1x" />
                          </span>
                        </div>
                        <input
                          type="tel"
                          name="phone"
                          value={data.phone}
                          className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                          placeholder="手机号码"
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {err.email && <small className="form-text text-danger">{err.email}</small>}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-transparent text-white border-0">
                            <FontAwesomeIcon icon={faEnvelope} fixedWidth size="1x" />
                          </span>
                        </div>
                        <input
                          type="text"
                          name="email"
                          value={data.email}
                          className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                          placeholder="邮箱地址"
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  )}

                  {err.name && <small className="form-text text-danger">{err.name}</small>}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <div className="input-group-prepend">
                      <span className="input-group-text bg-transparent text-white border-0">
                        <FontAwesomeIcon icon={faUserCircle} fixedWidth size="1x" />
                      </span>
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={data.name}
                      className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                      placeholder="用户名称"
                      onChange={handleChange}
                    />
                  </div>

                  {err.password1 && (
                    <small className="form-text text-danger">{err.password1}</small>
                  )}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <div className="input-group-prepend">
                      <span className="input-group-text bg-transparent text-white border-0">
                        <FontAwesomeIcon icon={faLock} fixedWidth size="1x" />
                      </span>
                    </div>
                    <input
                      type={hide ? "password" : "text"}
                      name="password1"
                      value={data.password1}
                      autoComplete="off"
                      className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                      placeholder="登录密码"
                      onChange={handleChange}
                    />
                    {hide ? (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide(false)}
                        >
                          <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                        </span>
                      </div>
                    ) : (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide(true)}
                        >
                          <FontAwesomeIcon icon={faEye} fixedWidth />
                        </span>
                      </div>
                    )}
                  </div>
                  {err.password2 && (
                    <small className="form-text text-danger">{err.password2}</small>
                  )}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <div className="input-group-prepend">
                      <span className="input-group-text bg-transparent text-white border-0">
                        <FontAwesomeIcon icon={faLock} fixedWidth size="1x" />
                      </span>
                    </div>
                    <input
                      type={hide1 ? "password" : "text"}
                      name="password2"
                      value={data.password2}
                      className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                      autoComplete="off"
                      placeholder="确认密码"
                      onChange={handleChange}
                    />
                    {hide1 ? (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide1(false)}
                        >
                          <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                        </span>
                      </div>
                    ) : (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide1(true)}
                        >
                          <FontAwesomeIcon icon={faEye} fixedWidth />
                        </span>
                      </div>
                    )}
                  </div>
                  {err.code && <small className="form-text text-danger">{err.code}</small>}
                  <div className="input-group row mb-1 input-group-lg input-control">
                    <input
                      type="text"
                      name="code"
                      value={data.code}
                      className="form-control col bg-transparent text-white border-0 input-placeholder input-f"
                      placeholder="验证码"
                      onChange={handleChange}
                    />
                    <div className="input-group-append">
                      {count.flag ? (
                        <button
                          type="button"
                          style={{ fontSize: 14 }}
                          disabled={checkInput()}
                          onClick={handleCode}
                          className="col btn btn-secondary btn-sm btn-outline-secondary border-0 text-white"
                        >
                          发送验证码
                        </button>
                      ) : (
                        <button
                          type="button"
                          style={{ fontSize: 14 }}
                          disabled="disabled"
                          className="col btn btn-secondary btn-sm btn-outline-secondary border-0 text-white"
                        >
                          已发送{count.countdown}s
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div className="text-white text-center mb-3">
                <span>
                  点击注册即您已同意
                  <a href="/wx/agt/user.html" className="text-decoration-none">
                    《用户协议》
                  </a>
                  和
                  <a href="/wx/agt/privacy.html" className="text-decoration-none">
                    《隐私政策》
                  </a>
                </span>
              </div>
              <div className="form-group row">
                <button
                  type="button"
                  style={{ width: "80%" }}
                  className="btn btn-block mx-auto rounded-pill button-background text-white"
                  onClick={handleSignIn}
                >
                  注&nbsp;册
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
